export default {
  make: (data, p) => ({
    header: `Запчасти на мопед ${data.make}`,
    header_uk: `Запчастини на мопед ${data.make}`,
  }),
  make_model: (data, p) => ({
    header: `Запчасти на мопед ${data.make} ${data.model}`,
    header_uk: `Запчастини на мопед ${data.make} ${data.model}`,

    title: `Запчасти на мопеды ${data.make} ${data.model} купить бу и новые в Украине - Автобазар`,
    title_uk: `Запчастини на мопеди ${data.make} ${data.model} купити бу і нові в Україні - Автобазар`,

    description: `Купить запчасти на мопед ${data.make} ${data.model} в Украине. В продаже запчасти для мопедов ${data.make} ${data.model} бу и новые. Большой каталог на Автобазар с фото, ценами`,
    description_uk: `Купити запчастини на мопед ${data.make} ${data.model} в Україні. У продажу запчастини для мопедів ${data.make} ${data.model} бу і нові. Великий каталог на Автобазар з фото, цінами`,
  }),
};



// WEBPACK FOOTER //
// ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/moped/templates.js